import React from "react";
import FormInput from "./FormInput";

export default props => <FormInput {...props} className="input-lg" />;



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormInput/LargeInput.jsx